/* global G */
import { deleteKey } from '@gaia/util'

/**
 * Transaction Begin Flag Remover
 *
 * Should be used in conjunction with `transactionBegin` hook.
 * Will also hide the loader.
 *
 * @param {Gaia.AppModule.Spec} obj - app module composition
 * @returns {function(...[*]): *[]}
 */
const transactionEnd = obj => (...args) => {
  const eventBus = obj[G.ADAPTER][G.EVENTS]

  eventBus.dispatch(eventBus.type(G.LOAD, G.DONE))

  deleteKey(G.UPDATE, obj[G.STATE])

  return args
}

export default transactionEnd
